"use client"

import { useCartStorage } from "@lib/hooks/use-cart-storage"
import ProductPrice from "../product-price"
import QuantitySelector from "../quantity-selector"
import { useState } from "react"

type ProductItemProps = {
  productTitle: string
  variantId: string
  productCode: string
  unit: string | "ks"
  price: number
}

const ProductItem = (props: ProductItemProps) => {
  const cartStorage = useCartStorage()

  const existingItemInCartStorage = cartStorage.items.find(
    (item) => item.variantID === props.variantId
  )

  const handleQuantityChange = async (num: number) => {
    const existingItem = cartStorage.items.find(
      (item) => item.variantID == props.variantId
    )

    if (!existingItem) {
      if (num > 0) {
        cartStorage.addItem(
          props.variantId,
          num,
          props.productTitle,
          props.productCode,
          props.unit,
          props.price
        )
      }
      return
    }

    if (num <= 0) {
      cartStorage.removeItem(props.variantId)
      return
    }

    cartStorage.changeAmount(props.variantId, num)
  }

  return (
    <tr className="h-14 w-full bg-[#FAFAF5] border border-[#E6E6E6] flex flex-row items-center col-span-3 first:rounded-t-2xl last:rounded-b-2xl">
      <td className="flex flex-row items-center justify-center flex-shrink h-full w-full max-w-[110px] min-w-[85px]">
        <span className="w-full font-bold text-center">
          {props.productCode}
        </span>
      </td>
      <td className="flex flex-row items-center justify-start w-full h-full">
        <span className="flex items-center justify-start flex-1 col-span-9 pl-3 font-medium text-center">
          {props.productTitle}
        </span>
      </td>

      <td className="flex flex-row h-full items-center justify-between w-full max-w-[150px] pl-1 pr-1 text-center border-l border-r border-[#E6E6E6] bg-[#faf9f5]">
        <ProductPrice price={props.price} unit={props.unit} />
      </td>

      <td className="flex flex-row h-full mx-2">
        <QuantitySelector
          onQuantityChanged={handleQuantityChange}
          variantID={props.variantId}
          value={existingItemInCartStorage?.count || 0}
        />
        {/* <button
          className="text-lg font-medium"
          onClick={() => handleQuantityChange(-1)}
        >
          -
        </button>
        <input
          data-input-counter
          className="text-center w-14 [&::-webkit-inner-spin-button]:appearance-none [appearance:textfield]"
          type="number"
          step={0.5}
          value={currentItem?.count || 0}
          name=""
          id=""
          min={0}
          onChange={(e) => {
            // handleQunatityChange()
          }}
          // onChange={(e) => {
          //   if(e.target.valueAsNumber % 5)
          // }}
        />
        <button
          className="text-lg font-medium"
          onClick={() => handleQuantityChange(1)}
        >
          +
        </button> */}
      </td>
    </tr>
    // <div className="w-[20rem] rounded-md h-[20rem] bg-[#FAFAF5] border-2 border-[#E6E6E6] flex flex-col items-center">
    //   <div className="w-full">
    //     <div className="flex pt-3 flex-col items-center justify-start w-full h-[4rem]">
    //       <h1 id="ProductName" className="text-xl font-medium">
    //         {props.productTitle}
    //       </h1>
    //       <h2
    //         id="ProductPrice"
    //         className="text-xl font-medium tracking-tight text-green-800"
    //       >
    //         {(props.productPrice / 100).toFixed(2).replace(".", ",")} Kč / 1{" "}
    //         {props.productUnit}
    //       </h2>
    //     </div>
    //   </div>

    //   <div id="ProductAddCartWrapper" className="flex flex-row w-full h-full">
    //     <div className="flex-initial w-1/3"></div>
    //     <div className="flex items-center justify-center flex-1 w-full">
    //       <div className="w-fit h-8 bg-white rounded-full border border-[#E6E6E6] flex items-center justify-center text-center">
    //         <span
    //           className="w-[2rem] pb-1 text-xl font-bold text-center cursor-pointer h-fit"
    //           onClick={() => {
    //             if (quantity > 1) {
    //               setQuantity(quantity - 1)
    //             }
    //           }}
    //         >
    //           ‒
    //         </span>

    //         {props.productUnit == "litr" ? (
    //           <input
    //             type="number"
    //             step={0.1}
    //             className="min-w-[2rem] w-full pl-2 h-full font-medium text-center bg-[#FAFAF5]"
    //             defaultValue={quantity}
    //             disabled={props.productUnit == "litr" ? false : true}
    //             onChange={(e) => {
    //               setQuantity(parseInt(e.target.value))
    //             }}
    //           />
    //         ) : (
    //           <span className="min-w-[2rem] w-full pl-2 pr-2 h-full pt-[3px] font-medium text-center bg-[#FAFAF5]">
    //             {quantity}
    //           </span>
    //         )}

    //         <span
    //           className="w-[2rem] pb-1 text-xl font-bold text-center cursor-pointer h-fit"
    //           onClick={() => {
    //             setQuantity(quantity + 1)
    //           }}
    //         >
    //           +
    //         </span>
    //       </div>
    //     </div>

    //     <div className="flex items-center justify-start flex-initial w-1/3">
    //       <BsCart3
    //         id="add_to_cart_button"
    //         className={`w-6 h-6 ml-5 cursor-pointer ${
    //           isSpinnerVisible ? "hidden" : ""
    //         }`}
    //         onClick={() => {
    //           setSpinnerVisible(true)
    //           addToCart({
    //             variantId: props.variantId,
    //             quantity: quantity,
    //             countryCode: props.countryCode,
    //           }).then(() => {
    //             setSpinnerVisible(false)
    //           })
    //         }}
    //       />

    //       <Spinner
    //         className={`ml-5 ${isSpinnerVisible ? "" : "hidden"} animate-spin`}
    //       />
    //     </div>
    //   </div>
    // </div>
  )
}

export default ProductItem
